import { useSelector } from "react-redux";
import * as localService from "../services/localService";

/**
 * Custom hook to access subscription data from Redux store
 * - Provides clean access to subscription state
 * - Already populated by postAuthFlow on login
 * - Follows pattern of useCurrencies and useCountries
 */
export const useSubscription = () => {
  const user = localService.getUser();
  const isIndividualCustomer = user?.organizationRole?.code === "ROLE_HOST_CUSTOMER_INDIVIDUAL";

  const {
    activeSubscription,
    subscriptions,
    recurringSubscriptions,
    addOnSubscriptions,
    activeAddOnSubscriptions,
    loading,
    error,
    subscriptionWallChecked,
  } = useSelector(state => ({
    activeSubscription: state.subscription?.activeSubscription || null,
    subscriptions: state.subscription?.subscriptions || [],
    recurringSubscriptions: state.subscription?.recurringSubscriptions || [],
    addOnSubscriptions: state.subscription?.addOnSubscriptions || [],
    activeAddOnSubscriptions: state.subscription?.activeAddOnSubscriptions || [],
    loading: state.subscription?.loading || false,
    error: state.subscription?.error || null,
    subscriptionWallChecked: state.subscription?.subscriptionWallChecked || false,
  }));

  const isDebugSkip =
    typeof window !== "undefined" &&
    window.location.hostname === "localhost" &&
    localStorage.getItem("debug_skip_subscription") === "true";

  return {
    activeSubscription,
    subscriptions,
    recurringSubscriptions,
    addOnSubscriptions,
    activeAddOnSubscriptions,
    loading,
    error,
    subscriptionWallChecked,
    hasActiveSubscription: isIndividualCustomer || isDebugSkip || !!activeSubscription,
  };
};
